import React, { useState } from "react";
import { Badge, Box, Chip, IconButton, ListItemText, Menu, MenuItem, Typography } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useTranslation } from "react-i18next";
import { TRANSLATION_MAP } from "../utils/reservation";

function FilterMenu({ options = [], setFilter, filter }) {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleOptionClick = (opt) => {
    setFilter(opt.key);
    handleClose();
  };

  return (
    <>
      <Box
        onClick={handleOpen}
        sx={{
          width: "100%",
          px: 2,
          py: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          border: "1px solid #EBEDF1",
          borderRadius: 2,
          bgcolor: open ? "#F5F7FA" : "transparent",
          "&:hover": { bgcolor: "#F5F7FA" },
        }}
      >
        <Typography variant='body2' sx={{ color: "#003C59", fontWeight: 500 }}>
          {t(`userDashboard.${TRANSLATION_MAP[filter]}`)}
        </Typography>
        <IconButton>
          <Badge
            badgeContent={options.length > 0 ? options.length : 0}
            color='primary'
            invisible={!options.length > 0 ? options.length : 0}
            sx={{
              "& .MuiBadge-badge": {
                bgcolor: "#003C59",
                fontSize: 10,
                fontWeight: 700,
                minWidth: 16,
                height: 16,
              },
            }}
          >
            <FilterListIcon sx={{ color: "#1A2233", fontSize: 22 }} />
          </Badge>
        </IconButton>
      </Box>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          paper: {
            sx: {
              mt: 0.5,
              minWidth: 220,
              borderRadius: 2,
              border: "1px solid #EBEDF1",
              boxShadow: "0 4px 20px rgba(20,30,50,0.08)",
            },
          },
        }}
      >
        {options.length === 0 && (
          <MenuItem disabled>
            <Typography variant='body2' sx={{ color: "text.secondary" }}>
              No filters available
            </Typography>
          </MenuItem>
        )}

        {options.map((opt, i) => (
          <MenuItem
            key={i}
            onClick={() => handleOptionClick(opt)}
            selected={!!(opt.key === filter)}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              backgroundColor: opt.key === filter ? "#003C59" : "transparent",
              gap: 2,
              py: 1,
            }}
          >
            <ListItemText
              primary={t(`userDashboard.${TRANSLATION_MAP[opt.label]}`)}
              primaryTypographyProps={{
                fontSize: 14,
                fontWeight: (opt.key === filter) ? 700 : 500,
              }}
            />
            <Chip
              size='small'
              label={opt.count}
              sx={{
                height: 20,
                fontSize: 11,
                fontWeight: 700,
                bgcolor: (opt.key === filter) ? "#003C59" : "#EBEDF1",
                color: (opt.key === filter) ? "#fff" : "#1A2233",
              }}
            />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

export default FilterMenu;
